import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, defineComponent } from 'vue'
const _hoisted_1 = {
  version: '1.1',
  xmlns: 'http://www.w3.org/2000/svg',
  'xmlns:xlink': 'http://www.w3.org/1999/xlink',
  x: '0px',
  y: '0px',
  viewBox: '0 0 512 512',
  'enable-background': 'new 0 0 512 512',
  'xml:space': 'preserve'
}
const _hoisted_2 = /*#__PURE__*/ _createElementVNode(
  'g',
  null,
  [
    /*#__PURE__*/ _createElementVNode('path', {
      d: 'M289,448h-66v-65h66V448z M288,350h-64c0-101,96-95.1,96-159c0-35.2-28.8-63.4-64-63.4S192,158,192,192h-64\r\n\t\tc0-71,57.3-128,128-128c70.7,0,128,56.4,128,127C384,270.9,288,280,288,350z'
    })
  ],
  -1
  /* HOISTED */
)
const _hoisted_3 = [_hoisted_2]
export default defineComponent({
  name: 'MdHelp',
  render: function render(_ctx, _cache) {
    return _openBlock(), _createElementBlock('svg', _hoisted_1, _hoisted_3)
  }
})
